import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart-line-icon',
  templateUrl: 'chart-line-icon.component.html'
})
export class ChartLineIconComponent {
  constructor() {}
}
